module.exports = __webpack_public_path__ + "img/imageIcon.b58014fb.svg";